<template>
	<div class="row pl-3">
		<div v-if="loading">
			<tile :loading="loading" :height="'4'" :width="'4'" class="loading-icon"></tile>
		</div>
		<!-- <div v-else>
			<span class="first-text"> {{ data }} </span>

		</div> -->
		<div v-else>
			<span class="nutnosti-title"> Tlapka: </span>
			<div class="nutnosti cetin-vysledek-card zmensit" :style="{ backgroundColor: data.message === 'Success' ? '#8bfc8d' : '#ff8c8c' }">
				<div v-if="data.success && data.data && data.data.addedServiceGroup">
					Jméno tarifu: {{ data.data.addedServiceGroup.name }} <br />
					Kategorie: {{ data.data.addedServiceGroup.ctuAttachmentCategory }} <br />
					Down Effective: {{ data.data.addedServiceGroup.speedDownEffective }} <br />
					Down Maximum: {{ data.data.addedServiceGroup.speedDownMaximum }} <br />
					Up Effective: {{ data.data.addedServiceGroup.speedUpEffective }} <br />
					Up Maximum: {{ data.data.addedServiceGroup.speedUpMaximum }} <br />
				</div>
				<div v-else-if="data.success && data.data"> Na adrese je dostupnost ale nemáme detaily. </div>
				<div v-else> Na této adrese není dostupnost. </div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TlapkaResult',

	props: {
		data: { type: Object },
		loading: { type: Boolean }
	},
}
</script>

<style lang="stylus" scoped>
.first-text
	font-size 20px

.nutnosti-title
	margin-top 20px
	font-size 24px
	font-weight bold
	border-top 1px solid #4CA5F9
	display flex


.nejpripo-vysledek
	display flex
	flex-direction column
	border-bottom 1px dashed #4CA5F9
	border-top 1px dashed #4CA5F9
	padding-bottom 10px
	padding-top 10px

.cetin-vysledek-card
	padding 10px
	background-color white
	border-radius 5px
	margin-right 10px
	margin-bottom 10px

.zmensit
	width 400px

.loading
	height 50px
	padding 0px

.loading-icon
	height 50px
	padding 0px !important
	margin-top -100px !important
</style>



// WEBPACK FOOTER //
// src/components/search_provider/results/TlapkaResult.vue